import React from 'react'

export default function About() {
    return (
        <div className="container mt-3">
            <h1 className="text-center">About</h1> <hr />
            <div className="container" >
                <strong>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero, culpa est! Fugit esse, illo, temporibus quos vero, nostrum commodi facere dolore unde exercitationem asperiores neque quibusdam consequatur modi ab quisquam.</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero, culpa est! Fugit esse, illo, temporibus quos vero, nostrum commodi facere dolore unde exercitationem asperiores neque quibusdam consequatur modi ab quisquam.</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero, culpa est! Fugit esse, illo, temporibus quos vero, nostrum commodi facere dolore unde exercitationem asperiores neque quibusdam consequatur modi ab quisquam.</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero, culpa est! Fugit esse, illo, temporibus quos vero, nostrum commodi facere dolore unde exercitationem asperiores neque quibusdam consequatur modi ab quisquam.</p>
                </strong>
            </div>
        </div>
    )
}
